import { Component, ChangeDetectionStrategy } from '@angular/core';
import {FormsModule} from '@angular/forms';
import {PoiOrgService, RetailDataDealerInformation} from './poi-org.service';

@Component({
    selector: 'app-poi-org',
    imports: [
        FormsModule,
    ],
    templateUrl: './poi-org.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './poi-org.component.scss'
})
export class PoiOrgComponent {

  constructor(
    private poiOrgService: PoiOrgService,
  ) {
  }

  context: string;
  value: string;
  environment: string;

  data: RetailDataDealerInformation;

  onSubmit() {

    switch (this.context) {
      case 'siteUid': {
        this.poiOrgService.getOrgBySiteUid(this.environment, this.value).subscribe(data => {
          this.data = data;
          console.info('here', this);
        });
        break;
      }
      case 'dealerContext': {
        this.poiOrgService.getOrgByDealerContext(this.environment, this.value).subscribe(data => {
          this.data = data;
        });
        break;
      }
    }
  }

  protected readonly JSON = JSON;
}
